@if (isAuthenticated$ | async) {
  <ui-header [links]="links$ | async"></ui-header>
  <router-outlet></router-outlet>
}
